/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Typography,
  Button,
  Box,
  Divider,
  IconButton,
  Snackbar,
  Grid,
  TextField,
  Dialog,
} from "@material-ui/core";
import useMediaQuery from "@mui/material/useMediaQuery";
import useIsDesktop from "../hooks/useIsDesktop";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { grey } from "@mui/material/colors";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Radio from "@mui/joy/Radio";
import RadioGroup from "@mui/joy/RadioGroup";
import Checkbox from "@mui/joy/Checkbox";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import defaultimg from "../assets/images/default.png";
import VegIcon from "../assets/images/Veg Icon 1.svg";
import NonVegIcon from "../assets/images/Non Veg Icon 1.svg";
import { BUTTON_COLOR, TEXT_COLOR } from "../utils/constant";
import ClearIcon from "@mui/icons-material/Clear";
import { addToCart } from "../store/actions/cartActions";
import { fontSize, padding } from "@mui/system";
import AddItemButton from "./AddItemButton";
import zIndex from "@material-ui/core/styles/zIndex";

// Styled components for the SwipeableDrawer
const drawerBleeding = 20;

const StyledBox = styled("div")(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.applyStyles?.("dark", {
    backgroundColor: grey[800],
  }),
}));

const AddonOption = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  padding: "5px 0",
});

const QuantityControl = styled("div")({
  display: "flex",
  alignItems: "center",
  marginBottom: "16px",
});

const StyledButton = styled(Button)({
  textTransform: "none",
  boxShadow: "none",
  borderRadius: "8px",
  padding: "10px 16px",
  fontWeight: 600,
});

const AddonCategory = styled("div")({
  marginBottom: "16px",
});

const getDietaryIconForItem = (item) => {
  let dietary = (item?.dietary || item?.item_variant?.[0]?.dietary || "").toLowerCase().trim();
  if (dietary === "veg") {
    return VegIcon;
  }
  if (dietary === "non-veg" || dietary === "nonveg" || dietary === "non veg" || dietary === "non_veg" || dietary === "egg" || dietary === "eggetarian" || dietary === "eggiterian" || dietary === "eggitarian") {
    return NonVegIcon;
  }
  return null;
};

const getDietaryIconForModifier = (modifier) => {
  let dietary = (modifier?.dietary || "").toLowerCase().trim();
  if (!dietary && modifier?.modifier_name) {
    const name = modifier.modifier_name.toLowerCase();
    if (name.includes("chicken") || name.includes("egg") || name.includes("mutton") || name.includes("fish") || name.includes("meat") || name.includes("bacon")) {
      dietary = "non-veg";
    } else if (name.includes("paneer") || name.includes("veg") || name.includes("potato") || name.includes("cheese") || name.includes("garlic") || name.includes("mayo") || name.includes("paratha") || name.includes("wheat")) {
      dietary = "veg";
    }
  }
  if (dietary === "veg") {
    return VegIcon;
  }
  if (dietary === "non-veg" || dietary === "nonveg" || dietary === "non veg" || dietary === "non_veg" || dietary === "egg" || dietary === "eggetarian" || dietary === "eggiterian" || dietary === "eggitarian") {
    return NonVegIcon;
  }
  return null;
};

const ItemModifier = function (props) {
  const dispatch = useDispatch();
  const cartProps = useSelector((state) => state.cartReducer);
  const {
    currency,
    modifierPopup,
    setModifierPopup,
    selectedItem,
    setSelectedItem,
    allitem,
    itemVerriantList,
    addonList,
    storeInfo,
    storeInfoConfig,
  } = props;

  let primaryColor = storeInfoConfig?.general_config?.primary_color;
  let secondaryColor = storeInfoConfig?.general_config?.secondary_color;
  let RequiredAddons = [];

  const { addedItems } = cartProps;
  const [selectedMod, setSelectedMod] = useState([]);
  const [selectedItemVariant, setSelectedItemVariant] = useState({});
  const [selectedAddon, setSelectedAddon] = useState([]);
  const [required, setRequired] = useState(false);
  const [open, setOpen] = useState(false);
  const [openRequired, setOpenRequired] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [itemspecialRequest, setItemspecialRequest] = useState("");
  const isDesktop = useIsDesktop();

  useEffect(() => {
    const item_variant = selectedItem?.item_variant || [];
    for (let i = 0; i < item_variant.length; i++) {
      const { modifier_varaint } = item_variant[i];
      const results = modifier_varaint?.filter(
        ({ mv_id: id1 }) => !selectedMod?.some(({ mv_id: id2 }) => id2 === id1)
      );
      if (!results?.length) {
        const changedVeriant = {
          ...selectedItem,
          item_variant: [item_variant[i]],
        };
        setSelectedItemVariant(changedVeriant);
        break;
      }
    }
  }, [selectedMod]);

  useEffect(() => {
    // When a new item is selected, pick the variant where `is_default === true`
    // If no such variant exists, fall back to the first one.
    if (selectedItem?._id && Array.isArray(selectedItem.item_variant)) {
      const defaultVariant =
        selectedItem.item_variant.find((variant) => variant.is_default) ||
        selectedItem.item_variant[0];

      const addedItemVariant = {
        ...selectedItem,
        item_variant: [defaultVariant],
      };

      const defaultMod = addedItemVariant?.item_variant[0]?.modifier_varaint || [];

      setSelectedItemVariant(addedItemVariant);
      setSelectedMod(defaultMod);
    } else {
      setSelectedItemVariant({});
      setSelectedMod([]);
    }

    setSelectedAddon([]);
    setQuantity(1);
    setItemspecialRequest("");
  }, [selectedItem]);

  const handleChangeMod = (item_modifier) => {
    const { mg_id, mv_id } = item_modifier;
    const filtered = selectedMod.filter((e) => !(e.mg_id === mg_id));
    setSelectedMod([...filtered, { mg_id, mv_id }]);
  };

  const getSeletedMod = (mg_id) => {
    if (!selectedMod?.length) return "";
    const reult = selectedMod.find((e) => e.mg_id === mg_id);
    return `${reult?.mg_id}_${reult?.mv_id}`;
  };

  const handleApply = () => {
    const allRequiredIncluded = RequiredAddons.every((required) => {
      const requiredGroupId = required.addon_group_id;

      const count = selectedAddon.filter(
        (selected) => selected.addon_group_id === requiredGroupId
      ).length;

      return count >= required.min_selection_count;
    });

    if (!allRequiredIncluded) {
      setOpenRequired(true);
    } else {
      const item = {
        ...selectedItemVariant,
        selected_addons_items: selectedAddon,
        specialRequest: itemspecialRequest,
        special_request: itemspecialRequest,
      };
      dispatch(addToCart(item, quantity));
      setModifierPopup(false);
      setSelectedItem(null);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setOpenRequired(false);
  };

  const toggleDrawer = (newOpen) => () => {
    if (!newOpen) {
      setModifierPopup(false);
      setSelectedItem(null);
    }
  };

  const increaseQuantity = () => {
    setQuantity((prevQuantity) => prevQuantity + 1);
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity((prevQuantity) => prevQuantity - 1);
    }
  };

  const calculateTotal = () => {
    let basePrice = selectedItemVariant?.item_variant?.length
      ? parseFloat(selectedItemVariant?.item_variant[0]?.plu) || 0
      : 0;

    // Add addon prices
    const addonPrice = selectedAddon.reduce((sum, addon) => {
      return sum + (parseFloat(addon?.item_variant?.[0]?.plu) || 0);
    }, 0);

    return ((basePrice + addonPrice) * quantity).toFixed(2);
  };

  const VariantAddon = () => {
    const { item_addons } = selectedItemVariant?.item_variant?.length
      ? selectedItemVariant?.item_variant[0]
      : {};
    let addongroup = [];

    // Check if item_addons exists and has any length
    if (item_addons?.length && !item_addons.includes("")) {
      // Iterate over each addon group ID in item_addons
      item_addons.forEach((addGrId) => {
        // Find the corresponding addon group from addonList using addon_group_id
        const addonGroup = addonList.find(
          (e) => e?.addon_group_id === addGrId && e?.status !== false && e?.status !== "false"
        );
        if (addonGroup) {
          addongroup.push(addonGroup);
        }
      });
    }

    let groupedAddonItems = {}; // Initialize an object to hold grouped addon items

    // Check if addongroup exists and has any length
    if (addongroup.length) {
      // Iterate over each addon group in addongroup
      for (let i = 0; i < addongroup.length; i++) {
        const group = addongroup[i];
        if (!group || group.status === false || group.status === "false") continue;

        // Initialize an object for the current addon group in the grouped object
        if (!groupedAddonItems[group?.addon_group_id]) {
          groupedAddonItems[group?.addon_group_id] = {
            addons_display_name: group?.addons_display_name,
            addon_group_id: group?.addon_group_id,
            addon_group_name: group?.addons_name,
            mappin_id: group?.mappin_id,
            selection_count: group?.selection_count,
            min_selection_count: group?.min_selection_count,
            required: group?.required,
            items: [],
          };
        }

        // Iterate through itemVerriantList to find all matching items
        itemVerriantList.forEach((item) => {
          if (item?.status === false || item?.status === "false") return;
          // Check all item variants for the current item
          const matchingVariants = (item?.item_variant || []).filter(
            (variant) =>
              variant?.status !== false &&
              variant?.status !== "false" &&
              group?.addons_list?.includes(variant?.sku)
          );

          // If any matching variants are found, add the item to the group's items array
          if (matchingVariants.length > 0) {
            groupedAddonItems[group?.addon_group_id].items.push(item);
          }
        });
      }
    }

    //     const checkSelectedAddon = (id) => {
    //   const filtered = selectedAddon.find((e) => e?._id === id);
    //   return filtered?._id ? true : false;
    // };

    const checkSelectedAddon = (sku) => {
      const filtered = selectedAddon.find((e) => e?.item_variant?.[0]?.sku === sku);
      return filtered ? true : false;
    };

    const handleChange = (group, item) => (event) => {
      const checked = event.target.checked;

      setSelectedAddon((val) => {
        if (checked) {
          if (group.selection_count === 1) {
            // Remove existing items from same group and add the selected one
            return [
              ...val.filter((e) => e.addon_group_id !== group.addon_group_id),
              {
                ...item,
                quantity: undefined,
                qty: undefined,
                addon_group_id: group.addon_group_id,
                addon_group_mappin_id: group.mappin_id,
                addon_group_name: group.addon_group_name,
              },
            ];
          }

          let addedAddons = val?.filter(
            (e) => e?.addon_group_id === group?.addon_group_id
          );
          if (addedAddons.length < group.selection_count) {
            return [
              ...val,
              {
                ...item,
                quantity: undefined,
                qty: undefined,
                addon_group_id: group.addon_group_id,
                addon_group_mappin_id: group.mappin_id,
                addon_group_name: group.addon_group_name,
              },
            ];
          } else {
            setOpen(true);
            return val;
          }
        } else {
          // return val.filter((itm) => itm?._id !== item?._id);
          return val.filter((itm) => itm?.item_variant?.[0]?.sku !== item?.item_variant?.[0]?.sku);
        }
      });
    };

    const action = (
      <React.Fragment>
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={handleClose}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </React.Fragment>
    );

    return (
      <Box style={{ padding: "0px", paddingBottom: "8px" }}>
        {Object.keys(groupedAddonItems).map((groupId) => {
          const group = groupedAddonItems[groupId];

          if (group?.required) {
            RequiredAddons.push(group);
          }

          return (
            <AddonCategory key={groupId} style={{ marginBottom: "16px"}}>
              <Typography
                style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  fontFamily: "Satoshi",
                  color: "#2D3748",
                  margin: isDesktop ? "16px 0 2px 0" : "16px 16px 2px 16px",
                  textAlign: "left",
                }}
              >
                {group.addons_display_name}
                {group.required && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
              </Typography>

              <Typography
                style={{
                  fontSize: "13px",
                  fontWeight: "500",
                  fontFamily: "Satoshi",
                  color: "#718096",
                  margin: isDesktop ? "2px 0 8px 0" : "2px 16px 8px 16px",
                  textAlign: "left",
                }}
              >
                {group.selection_count > 1 ? (
                  `Select up to ${group.selection_count}`
                ) : (
                  "Select any 1"
                )}
                {group.min_selection_count > 1 && (
                  ` | Select at least ${group.min_selection_count}`
                )}
              </Typography>

              <Box
                style={{
                  backgroundColor: isDesktop ? "white" : "white",
                  borderRadius: isDesktop ? "8px" : "12px",
                  border: isDesktop ? "1px solid #E5E5E5" : "1px solid #EDF2F7",
                  boxShadow: isDesktop ? "none" : "0px 0px 4px 0px #0000001F",
                  padding: isDesktop ? "0 16px" : "8px 16px",
                  margin: isDesktop ? "8px 0 20px 0" : "12px 16px",
                }}
              >
                {group.items?.map((item, index) => {
                  const dietaryIcon = getDietaryIconForItem(item);
                  const isSelected = checkSelectedAddon(item?.item_variant?.[0]?.sku);
                  const hasPrice = (item.item_variant[0]?.plu || 0) > 0;
                  const isOutOfStock = item.is_stock === false || item.item_variant?.some((v) => v.is_stock === false);

                  return (
                    <Box
                      key={`${item?.item_variant?.[0]?.sku || item._id}_${index}`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "12px 0",
                        borderBottom: "none",
                        opacity: isOutOfStock ? 0.6 : 1,
                      }}
                    >
                      {/* Left side: Veg Icon + Name */}
                      <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {dietaryIcon ? (
                          <img src={dietaryIcon} style={{ width: "15px", height: "15px" }} alt="" />
                        ) : null}
                        <span style={{ fontFamily: "Satoshi", fontSize: "14px", fontWeight: "500", color: isOutOfStock ? "#718096" : "#2D3748" }}>
                          {(item.item_name || item?.item_variant?.[0]?.item_name || "NA").replace(/\s*Regular\b/gi, "").trim()}
                          {isOutOfStock && (
                            <span style={{ color: "#E53E3E", fontSize: "12px", marginLeft: "6px", fontWeight: "700" }}>
                              (Out of Stock)
                            </span>
                          )}
                        </span>
                      </Box>
                      
                      {/* Right side: Price + Checkbox */}
                      <Box style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        {hasPrice && (
                          <span style={{ fontFamily: "Satoshi", fontSize: "14px", fontWeight: "500", color: "#4A5568" }}>
                            + {currency} {parseFloat(item.item_variant[0]?.plu || 0).toFixed(isDesktop ? 0 : 2)}
                          </span>
                        )}
                        <Checkbox
                          checked={isSelected}
                          disabled={isOutOfStock}
                          onChange={handleChange(group, item)}
                          sx={{
                            color: isSelected ? (primaryColor || BUTTON_COLOR || "#2196F3") : (primaryColor || BUTTON_COLOR || "#2196F3"),
                            "--variant-solidBg": primaryColor || BUTTON_COLOR || "#2196F3",
                            "--variant-solidBorder": primaryColor || BUTTON_COLOR || "#2196F3",
                            "--variant-outlinedBorder": primaryColor || BUTTON_COLOR || "#2196F3",
                            "--joy-palette-primary-solidBg": primaryColor || BUTTON_COLOR || "#2196F3",
                            "--joy-palette-neutral-solidBg": primaryColor || BUTTON_COLOR || "#2196F3",
                            "--joy-palette-neutral-outlinedBorder": primaryColor || BUTTON_COLOR || "#2196F3",
                            "& .JoyCheckbox-checkbox, & .MuiCheckbox-checkbox, & [class*='Checkbox-checkbox']": {
                              borderColor: (primaryColor || BUTTON_COLOR || "#2196F3") + " !important",
                              backgroundColor: (isSelected ? (primaryColor || BUTTON_COLOR || "#2196F3") : "transparent") + " !important",
                              color: (isSelected ? "#fff" : "transparent") + " !important",
                            },
                            "& .JoyCheckbox-action, & .MuiCheckbox-action, & [class*='Checkbox-action']": {
                              borderColor: (primaryColor || BUTTON_COLOR || "#2196F3") + " !important",
                            }
                          }}
                        />
                      </Box>
                    </Box>
                  );
                })}
              </Box>
              <Snackbar
                open={open}
                autoHideDuration={1500}
                onClose={handleClose}
                message={<span style={{ fontSize: "16px" }}>{`You can only select up to ${group.selection_count} items.`}</span>}
                action={action}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                style={{ bottom: "90px" }}
                ContentProps={{
                  sx: {
                    zIndex: 1000,
                    backgroundColor: 'var(--primary-color, #333)',
                    color: 'var(--secondary-color, #fff)',
                    fontFamily: 'Satoshi',
                    borderRadius: '8px',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                  }
                }}
              />
              <Snackbar
                open={openRequired}
                autoHideDuration={1500}
                onClose={handleClose}
                message={<span style={{ fontSize: "16px" }}>{`Select required addons.`}</span>}
                action={action}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                style={{ bottom: "80px" }}
                ContentProps={{
                  sx: {
                    zIndex: 1000,
                    backgroundColor: 'var(--primary-color, #333)',
                    color: 'var(--secondary-color, #fff)',
                    fontFamily: 'Satoshi',
                    borderRadius: '8px',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                  }
                }}
              />
            </AddonCategory>
          );
        })}
      </Box>
    );
  };

  return (
    <>
      <CssBaseline />
      {isDesktop ? (
        <Dialog
          open={modifierPopup}
          onClose={toggleDrawer(false)}
          PaperProps={{
            style: {
              borderRadius: "16px",
              padding: 0,
              width: "520px",
              maxWidth: "90vw",
              maxHeight: "90vh",
              overflow: "hidden",
              backgroundColor: "#FFF",
            },
          }}
        >
          {selectedItemVariant && (selectedItemVariant.item_name || selectedItem?.item_name) && (
            <>
              {/* Modal Header */}
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "16px 24px",
                  borderBottom: "1px solid #EEEEEE",
                }}
              >
                <Typography
                  style={{
                    fontWeight: 700,
                    fontSize: "18px",
                    fontFamily: "Satoshi",
                    color: "#1A1A1A",
                    textAlign: "left",
                  }}
                >
                  {selectedItemVariant.item_name || selectedItem?.item_name}
                </Typography>
                <CloseIcon
                  style={{
                    fontSize: "22px",
                    color: primaryColor || BUTTON_COLOR,
                    cursor: "pointer",
                  }}
                  onClick={toggleDrawer(false)}
                />
              </Box>

              {/* Modal Body */}
              <style>{`
                .custom-dialog-scrollbar::-webkit-scrollbar {
                  width: 6px;
                }
                .custom-dialog-scrollbar::-webkit-scrollbar-track {
                  background: #FAFAFA;
                  border-radius: 4px;
                }
                .custom-dialog-scrollbar::-webkit-scrollbar-thumb {
                  background: ${primaryColor || BUTTON_COLOR || '#eb5c24'}45;
                  border-radius: 4px;
                }
                .custom-dialog-scrollbar::-webkit-scrollbar-thumb:hover {
                  background: ${primaryColor || BUTTON_COLOR || '#eb5c24'}75;
                }
              `}</style>
              <Box className="custom-dialog-scrollbar" style={{ padding: "20px 24px", overflowY: "auto", maxHeight: "calc(90vh - 70px)" }}>
                {/* Top Item Summary Card */}
                <Box style={{ display: "flex", gap: "16px", marginBottom: "20px" }}>
                  <img
                    src={selectedItem?.item_display_img || defaultimg}
                    alt={selectedItem?.item_name}
                    style={{
                      width: "130px",
                      height: "115px",
                      objectFit: "cover",
                      borderRadius: "10px",
                      backgroundColor: "#F5F5F5",
                      flexShrink: 0,
                    }}
                    onError={(ev) => {
                      ev.target.onerror = null;
                      ev.target.src = defaultimg;
                    }}
                  />
                  <Box style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", flex: 1 }}>
                    <Box>
                      <Box style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "4px" }}>
                        {getDietaryIconForItem(selectedItem) && (
                          <img
                            src={getDietaryIconForItem(selectedItem)}
                            alt=""
                            style={{ width: "15px", height: "15px", flexShrink: 0 }}
                          />
                        )}
                        <Typography
                          style={{
                            fontWeight: 700,
                            fontSize: "16px",
                            color: "#1A1A1A",
                            fontFamily: "Satoshi",
                            textAlign: "left",
                          }}
                        >
                          {selectedItemVariant?.item_name || selectedItem?.item_name}
                        </Typography>
                      </Box>
                      {selectedItem?.description && (
                        <Typography
                          style={{
                            fontSize: "12px",
                            color: "#777",
                            lineHeight: 1.35,
                            fontFamily: "Satoshi",
                            textAlign: "left",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                          }}
                        >
                          {selectedItem.description}
                        </Typography>
                      )}
                    </Box>

                    <Box style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "8px" }}>
                      <Typography
                        style={{
                          fontWeight: 700,
                          fontSize: "20px",
                          color: primaryColor || BUTTON_COLOR,
                          fontFamily: "Satoshi",
                        }}
                      >
                        {currency} {parseFloat(selectedItemVariant?.item_variant?.[0]?.plu || selectedItem?.item_variant?.[0]?.plu || 0).toFixed(2)}
                      </Typography>

                      <Box
                        style={{
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: primaryColor || BUTTON_COLOR,
                          borderRadius: "4px",
                          padding: "4px 10px",
                          gap: "12px",
                          color: "white",
                        }}
                      >
                        <RemoveIcon
                          style={{ cursor: "pointer", fontSize: "16px", color: "white" }}
                          onClick={decreaseQuantity}
                        />
                        <span style={{ fontWeight: 700, fontSize: "15px", color: "white", fontFamily: "Satoshi", minWidth: "12px", textAlign: "center" }}>
                          {quantity}
                        </span>
                        <AddIcon
                          style={{ cursor: "pointer", fontSize: "16px", color: "white" }}
                          onClick={increaseQuantity}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>

                {/* Note to Kitchen Box */}
                <Box
                  style={{
                    border: `1px solid ${primaryColor || BUTTON_COLOR}`,
                    borderRadius: "8px",
                    padding: "8px 14px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "20px",
                    backgroundColor: "#FFF",
                  }}
                >
               <svg
                      width="18"
                      height="18"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ flexShrink: 0 }}
                    >
                      <path
                        d="M13.7682 1.962L12.0116 0.22213C11.8606 0.0795438 11.66 0 11.4513 0C11.2427 0 11.0421 0.0795438 10.8911 0.22213L9.32914 1.7739H0.94953C0.697699 1.7739 0.456182 1.87299 0.278111 2.04936C0.100039 2.22573 0 2.46494 0 2.71437V13.0595C0 13.309 0.100039 13.5482 0.278111 13.7245C0.456182 13.9009 0.697699 14 0.94953 14H11.3944C11.6462 14 11.8877 13.9009 12.0658 13.7245C12.2439 13.5482 12.3439 13.309 12.3439 13.0595V4.48245L13.7682 3.07175C13.9166 2.92451 14 2.72495 14 2.51687C14 2.3088 13.9166 2.10924 13.7682 1.962ZM7.04077 8.41832L5.0515 8.85563L5.52627 6.90416L10.0603 2.40402L11.5938 3.92287L7.04077 8.41832ZM12.1065 3.38681L10.573 1.86795L11.4513 0.998017L12.9848 2.51687L12.1065 3.38681Z"
                        fill={primaryColor || BUTTON_COLOR}
                      />
                    </svg>
                  <span style={{ fontWeight: 700, color: primaryColor || BUTTON_COLOR, fontSize: "14px", flexShrink: 0, fontFamily: "Satoshi" }}>
                    Note to Kitchen:
                  </span>
                  <input
                    type="text"
                    placeholder="Make it spicy"
                    value={itemspecialRequest}
                    onChange={(e) => setItemspecialRequest(e.target.value)}
                    style={{
                      border: "none",
                      outline: "none",
                      flex: 1,
                      fontSize: "14px",
                      fontFamily: "Satoshi",
                      color: "#333",
                      backgroundColor: "transparent",
                      width: "100%",
                    }}
                  />
                </Box>

                {/* Modifiers & Addons */}
                {selectedItem?.modifiers_group?.length > 0 &&
                  selectedItem?.modifiers_group[0]?.item_modifier?.length > 1 && (
                    <Box sx={{ mb: 2 }}>
                      {selectedItem.modifiers_group.map((group) => (
                        <React.Fragment key={group.mg_id}>
                          <Typography
                            style={{
                              fontSize: "15px",
                              fontWeight: "700",
                              fontFamily: "Satoshi",
                              color: "#2D3748",
                              marginBottom: "2px",
                              textAlign: "left",
                            }}
                          >
                            {group.modifier_display_name}
                          </Typography>
                          <Typography
                            style={{
                              fontSize: "13px",
                              fontWeight: "500",
                              fontFamily: "Satoshi",
                              color: "#718096",
                              marginBottom: "8px",
                              textAlign: "left",
                            }}
                          >
                            Select any 1
                          </Typography>
                          <Box
                            style={{
                              backgroundColor: "white",
                              borderRadius: "8px",
                              border: "1px solid #E5E5E5",
                              padding: "0 16px",
                              marginBottom: "20px",
                            }}
                          >
                            <RadioGroup>
                              {group.item_modifier.map((modifier, index) => {
                                const dietaryIcon = getDietaryIconForModifier(modifier);
                                const isSelected = getSeletedMod(modifier.mg_id) === `${modifier.mg_id}_${modifier.mv_id}`;
                                const hasPrice = (modifier.plu || 0) > 0;
                                const isOutOfStock = modifier.is_stock === false || selectedItem?.item_variant?.some((v) => 
                                  v.is_stock === false && v.modifier_varaint?.some((mv) => mv.mv_id === modifier.mv_id)
                                );

                                return (
                                  <Box
                                    key={modifier.mv_id}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      padding: "12px 0",
                                      borderBottom: "none",
                                      opacity: isOutOfStock ? 0.6 : 1,
                                    }}
                                  >
                                    <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                      {dietaryIcon && (
                                        <img src={dietaryIcon} style={{ width: "15px", height: "15px" }} alt="" />
                                      )}
                                      <span style={{ fontFamily: "Satoshi", fontSize: "14px", fontWeight: "500", color: isOutOfStock ? "#718096" : "#2D3748" }}>
                                        {modifier.modifier_name}
                                        {isOutOfStock && (
                                          <span style={{ color: "#E53E3E", fontSize: "12px", marginLeft: "6px", fontWeight: "700" }}>
                                            (Out of Stock)
                                          </span>
                                        )}
                                      </span>
                                    </Box>
                                    
                                    <Box style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                      {hasPrice && (
                                        <span style={{ fontFamily: "Satoshi", fontSize: "14px", fontWeight: "500", color: "#4A5568" }}>
                                          + {currency} {parseFloat(modifier.plu).toFixed(2)}
                                        </span>
                                      )}
                                      <Radio
                                        checked={isSelected}
                                        disabled={isOutOfStock}
                                        onChange={() => handleChangeMod(modifier)}
                                        value={`${modifier.mg_id}_${modifier.mv_id}`}
                                        sx={{
                                          "--Radio-checkedColor": primaryColor || BUTTON_COLOR,
                                          "--joy-palette-primary-outlinedBorder": primaryColor || BUTTON_COLOR,
                                          "--joy-palette-neutral-outlinedBorder": primaryColor || BUTTON_COLOR,
                                          "--joy-palette-primary-solidBg": primaryColor || BUTTON_COLOR,
                                          "--joy-palette-neutral-solidBg": primaryColor || BUTTON_COLOR,
                                          "& .JoyRadio-radio, & .MuiRadio-radio, & [class*='Radio-radio']": {
                                            borderColor: ((isSelected ? (primaryColor || BUTTON_COLOR) : "#CBD5E0")) + " !important",
                                            color: (isSelected ? (primaryColor || BUTTON_COLOR) : "transparent") + " !important",
                                            backgroundColor: "transparent !important",
                                          },
                                        }}
                                      />
                                    </Box>
                                  </Box>
                                );
                              })}
                            </RadioGroup>
                          </Box>
                        </React.Fragment>
                      ))}
                    </Box>
                  )}

                {/* Addon options */}
                {selectedItemVariant && <VariantAddon />}

                {/* Add To Cart Button inside scrollable body */}
                <Box>
                  <Button
                    fullWidth
                    variant="contained"
                    disableElevation
                    onClick={handleApply}
                    style={{
                      backgroundColor: primaryColor || BUTTON_COLOR,
                      color: "white",
                      borderRadius: "4px",
                      padding: "8px 20px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      textTransform: "none",
                      boxShadow: "none",
                    }}
                  >
                    <span style={{ fontSize: "18px", fontWeight: 700, fontFamily: "Satoshi" }}>
                      {currency} {calculateTotal()}
                    </span>
                    <span style={{ fontSize: "18px", fontWeight: 700, fontFamily: "Satoshi" }}>
                      Add To Cart
                    </span>
                  </Button>
                </Box>
              </Box>
            </>
          )}
        </Dialog>
      ) : (
      <SwipeableDrawer
        anchor="bottom"
        open={modifierPopup}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        disableSwipeToOpen={true}
        PaperProps={{
          style: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            maxHeight: "90%",
            backgroundColor: "white",
          },
        }}
      >
        <Box
          sx={{
            p: 2,
            overflow: "auto",
            maxHeight: "calc(100% - 50px)",
            padding: "0px",
          }}
        >
          {selectedItemVariant && selectedItemVariant.item_name && (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "white",
                  padding: "16px 20px",
                  borderBottom: "1px solid #EDF2F7",
                }}
              >
                <Typography
                  style={{
                    fontWeight: 700,
                    fontSize: "18px",
                    fontFamily: "Satoshi",
                    color: "#2D3748",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    flex: 1,
                    textAlign: "left",
                  }}
                >
                  {selectedItemVariant.item_name}
                </Typography>
                <CloseIcon
                  style={{
                    fontSize: "24px",
                    color: primaryColor || "#2196F3",
                    cursor: "pointer",
                    marginLeft: "12px",
                  }}
                  onClick={toggleDrawer(false)}
                />
              </Box>

              {/* <Divider sx={{ mb: 2 }} /> */}

              {selectedItem?.modifiers_group?.length > 0 &&
                selectedItem?.modifiers_group[0]?.item_modifier?.length > 1 && (
                  <Box sx={{ mb: 3 }}>
                    {selectedItem.modifiers_group.map((group) => (
                      <React.Fragment key={group.mg_id}>
                        <Typography
                          style={{
                            fontSize: "16px",
                            fontWeight: "700",
                            fontFamily: "Satoshi",
                            color: "#2D3748",
                            margin: "16px 16px 2px 16px",
                            textAlign: "left",
                          }}
                        >
                          {group.modifier_display_name}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: "13px",
                            fontWeight: "500",
                            fontFamily: "Satoshi",
                            color: "#718096",
                            margin: "2px 16px 8px 16px",
                            textAlign: "left",
                          }}
                        >
                          Select any 1
                        </Typography>
                        <Box
                          style={{
                            backgroundColor: "white",
                            borderRadius: "12px",
                            border: "1px solid #EDF2F7",
                            boxShadow: "0px 0px 4px 0px #0000001F",
                            padding: "8px 16px",
                            margin: "12px 16px",
                          }}
                        >
                          <RadioGroup>
                             {group.item_modifier.map((modifier, index) => {
                              const dietaryIcon = getDietaryIconForModifier(modifier);
                              const isSelected = getSeletedMod(modifier.mg_id) === `${modifier.mg_id}_${modifier.mv_id}`;
                              const hasPrice = (modifier.plu || 0) > 0;
                              const isOutOfStock = modifier.is_stock === false || selectedItem?.item_variant?.some((v) => 
                                v.is_stock === false && v.modifier_varaint?.some((mv) => mv.mv_id === modifier.mv_id)
                              );
                              
                              return (
                                <Box
                                  key={modifier.mv_id}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "12px 0",
                                    borderBottom: "none",
                                    opacity: isOutOfStock ? 0.6 : 1,
                                  }}
                                >
                                  {/* Left side: Veg Icon + Name */}
                                  <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    {dietaryIcon ? (
                                      <img src={dietaryIcon} style={{ width: "15px", height: "15px" }} alt="" />
                                    ) : null}
                                    <span style={{ fontFamily: "Satoshi", fontSize: "14px", fontWeight: "500", color: isOutOfStock ? "#718096" : "#2D3748" }}>
                                      {modifier.modifier_name}
                                      {isOutOfStock && (
                                        <span style={{ color: "#E53E3E", fontSize: "12px", marginLeft: "6px", fontWeight: "700" }}>
                                          (Out of Stock)
                                        </span>
                                      )}
                                    </span>
                                  </Box>
                                  
                                  {/* Right side: Price + Radio */}
                                  <Box style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                    {hasPrice && (
                                      <span style={{ fontFamily: "Satoshi", fontSize: "14px", fontWeight: "500", color: "#4A5568" }}>
                                        + {currency}{parseFloat(modifier.plu).toFixed(2)}
                                      </span>
                                    )}
                                    <Radio
                                      checked={isSelected}
                                      disabled={isOutOfStock}
                                      onChange={() => handleChangeMod(modifier)}
                                      value={`${modifier.mg_id}_${modifier.mv_id}`}
                                      sx={{
                                        "--Radio-checkedColor": primaryColor || "#2196F3",
                                        "--joy-palette-primary-outlinedBorder": primaryColor || "#2196F3",
                                        "--joy-palette-neutral-outlinedBorder": primaryColor || "#2196F3",
                                        "--joy-palette-primary-solidBg": primaryColor || "#2196F3",
                                        "--joy-palette-neutral-solidBg": primaryColor || "#2196F3",
                                        "& .JoyRadio-radio, & .MuiRadio-radio, & [class*='Radio-radio']": {
                                          borderColor: ((isSelected ? primaryColor : "#CBD5E0") || "#2196F3") + " !important",
                                          color: (isSelected ? (primaryColor || "#2196F3") : "transparent") + " !important",
                                          backgroundColor: "transparent !important",
                                        },
                                        "& .JoyRadio-action, & .MuiRadio-action, & [class*='Radio-action']": {
                                          borderColor: (isSelected ? (primaryColor || "#2196F3") : "#CBD5E0") + " !important",
                                        }
                                      }}
                                    />
                                  </Box>
                                </Box>
                              );
                            })}
                          </RadioGroup>
                        </Box>
                      </React.Fragment>
                    ))}
                  </Box>
                )}

              {/* Addon options */}
              {selectedItemVariant && <VariantAddon />}

              <Box style={{ padding: "0 16px 16px 16px" }}>
                <style>{`
                  .special-request-textfield .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
                    border-color: ${primaryColor || "#3f51b5"} !important;
                  }
                `}</style>
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    fontFamily: "Satoshi",
                    color: "#2D3748",
                    margin: "16px 0 8px 0",
                    textAlign: "left",
                  }}
                >
                  Special Request
                </Typography>
                <TextField
                  className="special-request-textfield"
                  fullWidth
                  variant="outlined"
                  placeholder="e.g. Dont make it too spicy"
                  value={itemspecialRequest}
                  onChange={(e) => setItemspecialRequest(e.target.value)}
                  multiline
                  rows={1}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                      borderRadius: "12px",
                      boxShadow: "0px 0px 4px 0px #0000001F",
                      fontFamily: "Satoshi",
                      fontSize: "14px",
                    },
                  }}
                />
              </Box>
            </>
          )}
        </Box>

        <Box
          sx={{
            p: 2,
            borderTop: "1px solid #f0f0f0",
            position: "sticky",
            bottom: 0,
            bgcolor: "#fff",
            justifyContent: "space-between",
            alignItems: "center",
            boxShadow: "0px -2px 10px rgba(0,0,0,0.05)",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "12px",
              alignItems: "stretch",
            }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{
                float: "right",
                display: "flex",
                padding: "0.5rem",
                // boxShadow:
                //   "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
                justifyContent: "space-evenly",
                alignContent: "center",
                alignItems: "center",
                border: "0.5px solid #d4d4d4",
                minWidth: "5.5em",
                borderRadius: "0.6rem",
                backgroundColor: primaryColor || BUTTON_COLOR,
              }}
            >
              <Grid container xs={4} sm={4} md={4} lg={4}>
                <RemoveIcon
                  style={{
                    color: "white",
                    backgroundColor: primaryColor || BUTTON_COLOR,
                    height: "25px",
                    width: "20px",
                    borderRadius: "0.3rem 0rem 0rem 0.3rem",

                    // padding: "0rem 0.3rem",
                  }}
                  onClick={() => decreaseQuantity()}
                />
              </Grid>
              <Grid
                xs={4}
                sm={4}
                md={4}
                lg={4}
                style={{
                  display: "flex",
                  color: "white" || TEXT_COLOR,
                  justifyContent: "center",
                  backgroundColor: primaryColor || BUTTON_COLOR,
                }}
              >
                <Typography>
                  <span
                    style={{
                      fontSize: "1.3rem",
                      color:  "white"  || TEXT_COLOR,
                      fontWeight: "600",
                    }}
                  >
                    {quantity}
                  </span>
                </Typography>
              </Grid>
              <Grid
                container
                justifyContent="flex-end"
                xs={4}
                sm={4}
                md={4}
                lg={4}
              >
                <AddIcon
                  style={{
                    height: "25px",
                    width: "20px",
                    color:  "white"  || TEXT_COLOR,
                    backgroundColor: primaryColor || BUTTON_COLOR,
                    borderRadius: "0rem 0.3rem 0.3rem 0rem",
                  }}
                  onClick={() => increaseQuantity()}
                />
              </Grid>
            </Grid>

            {/* Add to Cart Button - 70% */}
            <Button
              variant="contained"
              disableElevation
              onClick={handleApply}
              style={{
                fontSize: "1.3rem",
                borderRadius: "8px",
                minWidth: "70%",
                color:  "white"  || TEXT_COLOR,
                backgroundColor: primaryColor || BUTTON_COLOR,
                boxShadow: "none",
              }}
            >
              Add to cart: {currency}
              {calculateTotal()}
            </Button>
          </div>
        </Box>
      </SwipeableDrawer>
      )}
    </>
  );
};

export default ItemModifier;
